module.exports = __webpack_public_path__ + "img/SKMJ_cap2.e95a1e66.jpg";